/********************************************************************
 * Generated by RxDjango on 2026-05-14 19:30 (UTC)                  *
 *                                                                  *
 * Based on all ContextChannel subclasses in authorization.channels *
 *                                                                  *
 *                       DO NOT EDIT THIS FILE                      *
 *                                                                  *
 * To rebuild it, run:                                              *
 *                                                                  *
 *     ./manage.py makefrontend [authorization]                     *
 *                                                                  *
 ********************************************************************/

import { ContextChannel } from '@rxdjango/react';

const SOCKET_URL = (process.env.REACT_APP_RX_WEBSOCKET_URL ?? 'ws://localhost:8000') as string;

export class AuthorizationChannel extends ContextChannel {

  protected endpoint: string = "/ws/authorization/";
  protected baseURL: string = SOCKET_URL;

  authorized: boolean = false;
  counter: number = 0;

  authorize = async (password: string) => {
    return await this.rx.callAction('authorize', [password]);
  };

  increment = async () => {
    return await this.rx.callAction('increment', []);
  };
}
